import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

// Import helpers
import { checkIsFavourite } from 'helpers/epg';
import { addFavourite, deleteFavourite } from 'store/actions';

const useFavouriteButton = ({ uuid, GTMEvent }) => {
	const ref = useRef();
	const dispatch = useDispatch();
	const { pathname } = useLocation();
	const { t } = useTranslation();
	const favourites = useSelector(({ favourites }) => favourites.data);

	const isFavourite = checkIsFavourite(favourites, uuid);

	const handleClick = () => {
		GTMEvent && GTMEvent({ pathname, label: buttonText });
		if (isFavourite) {
			return deleteFavourite(uuid)(dispatch);
		}
		return addFavourite(uuid)(dispatch);
	};

	const buttonText = isFavourite
		? t('vod_buttons_favourite_delete')
		: t('vod_buttons_favourite_add');

	return {
		buttonText,
		handleClick,
		ref,
		isFavourite
	};
};

export default useFavouriteButton;
